// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog {
  padding: 8rem 0;
  background: #000;
  position: relative;
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5px;
}

.blog-card {
  position: relative;
  background: #0a0a0a;
  overflow: hidden;
  cursor: pointer;
  transition: background 0.3s;
}

.blog-card:hover {
  background: #0f0f0f;
}

.blog-placeholder {
  width: 100%;
  height: 200px;
  background: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255,255,255,0.04);
  overflow: hidden;
}

.blog-placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.7rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.2);
}

.blog-placeholder-content span:first-child {
  font-size: 2rem;
  animation: pulsePlaceholder 2.5s ease-in-out infinite;
}

.blog-content {
  padding: 1.8rem;
}

.blog-tag {
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 0.8rem;
}

.blog-post-title {
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.5;
  color: rgba(255,255,255,0.85);
  margin-bottom: 1.5rem;
  transition: color 0.3s;
}

.blog-card:hover .blog-post-title {
  color: #fff;
}

.blog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blog-date {
  font-size: 0.75rem;
  color: rgba(255,255,255,0.2);
  letter-spacing: 0.1em;
}

.blog-read {
  font-size: 0.75rem;
  color: var(--accent, #bf00ff);
  letter-spacing: 0.1em;
  opacity: 0;
  transform: translateX(-8px);
  transition: all 0.3s;
}

.blog-card:hover .blog-read {
  opacity: 1;
  transform: translateX(0);
}

.blog-card-line {
  position: absolute;
  bottom: 0; left: 0;
  width: 0; height: 2px;
  background: var(--accent, #bf00ff);
  transition: width 0.4s ease;
}

.blog-card:hover .blog-card-line {
  width: 100%;
}

@media (max-width: 768px) {
  .blog-grid { grid-template-columns: 1fr; }
  .blog { padding: 5rem 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Blog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO;EAClB,QAAQ,EAAE,WAAW;EACrB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa,0BAA0B,EAAE;EACzC,QAAQ,eAAe,EAAE;AAC3B","sourcesContent":[".blog {\n  padding: 8rem 0;\n  background: #000;\n  position: relative;\n}\n\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5px;\n}\n\n.blog-card {\n  position: relative;\n  background: #0a0a0a;\n  overflow: hidden;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.blog-card:hover {\n  background: #0f0f0f;\n}\n\n.blog-placeholder {\n  width: 100%;\n  height: 200px;\n  background: #111;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n  overflow: hidden;\n}\n\n.blog-placeholder-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.7rem;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.2);\n}\n\n.blog-placeholder-content span:first-child {\n  font-size: 2rem;\n  animation: pulsePlaceholder 2.5s ease-in-out infinite;\n}\n\n.blog-content {\n  padding: 1.8rem;\n}\n\n.blog-tag {\n  font-size: 0.7rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: 0.8rem;\n}\n\n.blog-post-title {\n  font-size: 1.05rem;\n  font-weight: 600;\n  line-height: 1.5;\n  color: rgba(255,255,255,0.85);\n  margin-bottom: 1.5rem;\n  transition: color 0.3s;\n}\n\n.blog-card:hover .blog-post-title {\n  color: #fff;\n}\n\n.blog-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blog-date {\n  font-size: 0.75rem;\n  color: rgba(255,255,255,0.2);\n  letter-spacing: 0.1em;\n}\n\n.blog-read {\n  font-size: 0.75rem;\n  color: var(--accent, #bf00ff);\n  letter-spacing: 0.1em;\n  opacity: 0;\n  transform: translateX(-8px);\n  transition: all 0.3s;\n}\n\n.blog-card:hover .blog-read {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.blog-card-line {\n  position: absolute;\n  bottom: 0; left: 0;\n  width: 0; height: 2px;\n  background: var(--accent, #bf00ff);\n  transition: width 0.4s ease;\n}\n\n.blog-card:hover .blog-card-line {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .blog-grid { grid-template-columns: 1fr; }\n  .blog { padding: 5rem 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
